// Simple in-memory cache for mapping listingId to PDF data
// Each entry shape: { listingId: string|number, pdfUrl: string, images?: string[], totalPages?: number, timestamp: number }

const pdfUrlCache = [];

export function cachePdfUrl(listingId, pdfUrl) {
  if (!listingId || !pdfUrl) return;
  const exists = pdfUrlCache.find(
    (entry) => entry.listingId === listingId && entry.pdfUrl === pdfUrl
  );
  if (!exists) {
    pdfUrlCache.push({ listingId, pdfUrl, timestamp: Date.now() });
  }
}

export function getCachedPdfUrl(listingId) {
  if (!listingId) return null;
  const found = pdfUrlCache.find((entry) => entry.listingId === listingId);
  return found ? found.pdfUrl : null;
}

export function getAllCachedPdfUrls() {
  return pdfUrlCache.slice();
}

export function cachePdfData(listingId, pdfUrl, images, totalPages, type = "full") {
  if (!listingId || !pdfUrl) return;
  const idx = pdfUrlCache.findIndex(
    (entry) => entry.listingId === listingId && entry.pdfUrl === pdfUrl && entry.type === type
  );
  const payload = {
    listingId,
    pdfUrl,
    images: images || [],
    totalPages: totalPages || 0,
    type,
    timestamp: Date.now()
  };
  if (idx >= 0) {
    pdfUrlCache[idx] = payload;
  } else {
    pdfUrlCache.push(payload);
  }
}

export function getCachedPdfData(listingId, type = "full") {
  if (!listingId) return null;
  return pdfUrlCache.find((entry) => entry.listingId === listingId && entry.type === type) || null;
}

export default pdfUrlCache;
